module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Document"},"ar":{"title":"وثيقة"}}')
  delete Component.options._Ctor
}
